var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_86061",
    "data-name": "Group 86061",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.087,
    height: 24.69,
    viewBox: "0 0 24.087 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25108",
    "data-name": "Rectangle 25108",
    width: 24.087,
    height: 24.69,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86060",
    "data-name": "Group 86060",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242461",
    "data-name": "Path 242461",
    d: "M5.257,11.513H2.415a.385.385,0,0,1-.385-.386V8.286A.385.385,0,0,1,2.415,7.9H5.257a.386.386,0,0,1,.386.386v2.841a.386.386,0,0,1-.386.386M2.8,10.742h2.07V8.672H2.8Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242462",
    "data-name": "Path 242462",
    d: "M10.112,11.513H7.271a.386.386,0,0,1-.386-.386V8.286A.386.386,0,0,1,7.271,7.9h2.841a.386.386,0,0,1,.386.386v2.841a.386.386,0,0,1-.386.386m-2.456-.771h2.07V8.672H7.656Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242463",
    "data-name": "Path 242463",
    d: "M14.968,11.513H12.126a.386.386,0,0,1-.386-.386V8.286a.386.386,0,0,1,.386-.386h2.842a.385.385,0,0,1,.385.386v2.841a.386.386,0,0,1-.385.386m-2.456-.771h2.07V8.672h-2.07Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242464",
    "data-name": "Path 242464",
    d: "M19.823,11.513H16.981a.385.385,0,0,1-.385-.386V8.286a.385.385,0,0,1,.385-.386h2.842a.386.386,0,0,1,.386.386v2.841a.386.386,0,0,1-.386.386m-2.456-.771h2.07V8.672h-2.07Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242465",
    "data-name": "Path 242465",
    d: "M5.257,15.9H2.415a.385.385,0,0,1-.385-.386V12.669a.385.385,0,0,1,.385-.386H5.257a.386.386,0,0,1,.386.386V15.51a.386.386,0,0,1-.386.386M2.8,15.124h2.07v-2.07H2.8Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242466",
    "data-name": "Path 242466",
    d: "M10.112,15.9H7.271a.386.386,0,0,1-.386-.386V12.669a.386.386,0,0,1,.386-.386h2.841a.386.386,0,0,1,.386.386V15.51a.386.386,0,0,1-.386.386m-2.456-.772h2.07v-2.07H7.656Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242467",
    "data-name": "Path 242467",
    d: "M5.257,20.279H2.415a.385.385,0,0,1-.385-.386V17.051a.385.385,0,0,1,.385-.385H5.257a.385.385,0,0,1,.386.385v2.842a.386.386,0,0,1-.386.386M2.8,19.507h2.07v-2.07H2.8Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242468",
    "data-name": "Path 242468",
    d: "M10.112,20.279H7.271a.386.386,0,0,1-.386-.386V17.051a.385.385,0,0,1,.386-.385h2.841a.385.385,0,0,1,.386.385v2.842a.386.386,0,0,1-.386.386m-2.456-.772h2.07v-2.07H7.656Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242469",
    "data-name": "Path 242469",
    d: "M13.167,22.308H1.543A1.545,1.545,0,0,1,0,20.764V6.256A.385.385,0,0,1,.385,5.87H21.852a.386.386,0,0,1,.386.386v7.956a.386.386,0,0,1-.772,0V6.642H.771V20.764a.773.773,0,0,0,.772.772H13.167a.386.386,0,1,1,0,.772",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242470",
    "data-name": "Path 242470",
    d: "M21.852,6.642H.385A.385.385,0,0,1,0,6.256V3.569A1.545,1.545,0,0,1,1.543,2.026H3.495a.386.386,0,1,1,0,.771H1.543a.773.773,0,0,0-.772.772v2.3H21.466v-2.3a.773.773,0,0,0-.772-.772H18.742a.386.386,0,0,1,0-.771h1.952a1.545,1.545,0,0,1,1.544,1.543V6.256A.386.386,0,0,1,21.852,6.642Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242471",
    "data-name": "Path 242471",
    d: "M17.045,2.8H5.193a.386.386,0,0,1,0-.772H17.045a.386.386,0,0,1,0,.772",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242472",
    "data-name": "Path 242472",
    d: "M4.344,4.824A1.236,1.236,0,0,1,3.109,3.589V1.235a1.235,1.235,0,1,1,2.47,0V3.589A1.236,1.236,0,0,1,4.344,4.824m0-4.052a.464.464,0,0,0-.463.463V3.589a.463.463,0,1,0,.926,0V1.235A.464.464,0,0,0,4.344.772",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242473",
    "data-name": "Path 242473",
    d: "M17.894,4.824a1.236,1.236,0,0,1-1.235-1.235V1.235a1.235,1.235,0,1,1,2.47,0V3.589a1.236,1.236,0,0,1-1.235,1.235m0-4.052a.464.464,0,0,0-.463.463V3.589a.463.463,0,0,0,.926,0V1.235a.464.464,0,0,0-.463-.463",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242474",
    "data-name": "Path 242474",
    d: "M17.869,24.69a6.206,6.206,0,1,1,2.42-.489,6.164,6.164,0,0,1-2.42.489m0-11.664a5.446,5.446,0,1,0,5.446,5.446,5.452,5.452,0,0,0-5.446-5.446",
    fill: "#ff6464",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242475",
    "data-name": "Path 242475",
    d: "M17.869,23.061a4.589,4.589,0,1,1,3.244-1.344A4.554,4.554,0,0,1,17.869,23.061Zm0-8.405a3.816,3.816,0,1,0,3.817,3.817A3.821,3.821,0,0,0,17.869,14.656Z",
    fill: "#ff6464",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242476",
    "data-name": "Path 242476",
    d: "M19.182,20.171a.387.387,0,0,1-.273-.113L17.6,18.745a.386.386,0,0,1-.113-.273V16a.386.386,0,1,1,.772,0v2.316l1.2,1.2a.386.386,0,0,1-.273.659Z",
    fill: "#ff6464",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTime);
export default __webpack_public_path__ + "static/media/calendar-time.3a99d5f7707c601cdd98c2466f6e4597.svg";
export { ForwardRef as ReactComponent };